/* Choose Your Liberty: sort prints, then made-to-order customise flow. */
(function () {
  var grids = document.querySelectorAll('[data-lc-liberty-grid]');
  grids.forEach(function (grid) {
    if (!grid.hasAttribute('data-lc-liberty-sort')) return;
    var items = Array.prototype.slice.call(grid.children);
    items.sort(function (a, b) {
      return Number(a.getAttribute('data-sort') || 9999) - Number(b.getAttribute('data-sort') || 9999);
    });
    items.forEach(function (item) {
      grid.appendChild(item);
    });
  });

  var root = document.querySelector('[data-lc-liberty-root]');
  if (!root) return;

  var browse = root.querySelector('[data-lc-library-browse]');
  var panel = root.querySelector('[data-lc-customise]');
  if (!panel) return;

  var printPhoto = panel.querySelector('[data-lc-print-photo]');
  var printMedia = panel.querySelector('[data-lc-print-media]');
  var printCaption = panel.querySelector('[data-lc-print-caption]');
  var printTitle = panel.querySelector('[data-lc-print-title]');
  var summaryTitle = panel.querySelector('[data-lc-summary-title]');
  var summaryPrint = panel.querySelector('[data-lc-summary-print]');
  var summaryItem = panel.querySelector('[data-lc-summary-item]');
  var summaryOptions = panel.querySelector('[data-lc-summary-options]');
  var summaryPrice = panel.querySelector('[data-lc-summary-price]');
  var summaryEmbroideryRow = panel.querySelector('[data-lc-summary-embroidery-row]');
  var summaryEmbroideryFee = panel.querySelector('[data-lc-summary-embroidery-fee]');
  var summaryName = panel.querySelector('[data-lc-summary-name]');
  var summaryColour = panel.querySelector('[data-lc-summary-colour]');
  var summaryTotal = panel.querySelector('[data-lc-summary-total]');
  var honestyNote = panel.querySelector('[data-lc-honesty]');
  var embroideryVariantId = Number(panel.getAttribute('data-embroidery-variant') || 0) || 0;
  var embroideryFeeCents = Number(panel.getAttribute('data-embroidery-cents') || 3000) || 3000;
  var itemStep = panel.querySelector('[data-lc-item-step]');
  var chosenWrap = panel.querySelector('[data-lc-chosen-piece]');
  var chosenLabel = panel.querySelector('[data-lc-chosen-piece-label]');
  var pieceOptions = panel.querySelector('[data-lc-piece-options]');
  var personalise = panel.querySelector('[data-lc-personalise]');
  var totalsBox = panel.querySelector('[data-lc-totals]');
  var optionsWrap = panel.querySelector('[data-lc-options]');
  var fabricNote = panel.querySelector('[data-lc-fabric-note]');
  var sleeveNote = panel.querySelector('[data-lc-sleeve-note]');
  var categorySelect = panel.querySelector('[data-lc-category]');
  var pieceSelect = panel.querySelector('[data-lc-piece]');
  var catEmpty = panel.querySelector('[data-lc-cat-empty]');
  var textInput = panel.querySelector('[data-lc-embroidery-text]');
  var textLabel = panel.querySelector('[data-lc-text-label]');
  var textCount = panel.querySelector('[data-lc-text-count]');
  var textMax = panel.querySelector('[data-lc-text-max]');
  var form = panel.querySelector('[data-lc-customise-form]');
  var submit = panel.querySelector('[data-lc-customise-submit]');
  var errorBox = panel.querySelector('[data-lc-customise-error]');
  var variantInput = panel.querySelector('[data-lc-variant-id]');
  var propFabric = panel.querySelector('[data-lc-prop-fabric]');
  var propName = panel.querySelector('[data-lc-prop-name]');
  var propColour = panel.querySelector('[data-lc-prop-colour]');
  var propEmbroidery = panel.querySelector('[data-lc-prop-embroidery]');

  var state = {
    printHandle: '',
    printName: '',
    printImage: '',
    product: null,
    optionValues: {},
    colour: '',
    mode: 'name',
    category: 'bags',
    changingPiece: false,
  };
  var orderWasReady = false;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function isOneSize(value) {
    var key = normalize(value);
    return key === 'one size' || key === 'onesize' || key === 'unique' || key === 'os';
  }

  function isFabricOption(option) {
    if (!option) return false;
    if (option.fabric) return true;
    var key = normalize(option.name);
    return key === 'color' || key === 'colour' || key === 'print' || key === 'fabric' || key === 'liberty';
  }

  function isPrintOption(option) {
    return isFabricOption(option);
  }

  function uniqueValues(values) {
    var seen = {};
    var out = [];
    (values || []).forEach(function (value) {
      var label = String(value || '').trim();
      if (!label) return;
      var key = normalize(label);
      if (seen[key]) return;
      seen[key] = true;
      out.push(label);
    });
    return out;
  }

  var SLEEVE_SIZE_LABELS = [
    'iPad (28×22 cm)',
    'Medium laptop (35×25 cm)',
    'Large laptop (37×27 cm)',
  ];

  function isSleeveProduct(product) {
    if (!product) return false;
    if (product.sleeve) return true;
    var handle = normalize(product.handle);
    var title = normalize(product.title);
    if (handle.indexOf('pencil') !== -1 || title.indexOf('pencil') !== -1) return false;
    var blob = handle + ' ' + title;
    return blob.indexOf('sleeve') !== -1 || blob.indexOf('laptop') !== -1 || blob.indexOf('ipad') !== -1;
  }

  function isSizeOption(option) {
    if (!option) return false;
    if (option.size) return true;
    return normalize(option.name) === 'size';
  }

  function compactSize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/×/g, 'x')
      .replace(/\*/g, 'x')
      .replace(/–/g, 'x')
      .replace(/-/g, ' ')
      .replace(/[^a-z0-9x]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatSleeveSize(value) {
    var key = compactSize(value);
    if ((key.indexOf('28') !== -1 && key.indexOf('22') !== -1) || key.indexOf('ipad') !== -1) {
      return SLEEVE_SIZE_LABELS[0];
    }
    if ((key.indexOf('35') !== -1 && key.indexOf('25') !== -1) || key.indexOf('medium') !== -1) {
      return SLEEVE_SIZE_LABELS[1];
    }
    if ((key.indexOf('37') !== -1 && key.indexOf('27') !== -1) || key.indexOf('large') !== -1) {
      return SLEEVE_SIZE_LABELS[2];
    }
    return String(value || '').trim();
  }

  function optionLabel(product, option, value) {
    if (isSleeveProduct(product) && isSizeOption(option)) return formatSleeveSize(value);
    return String(value || '').trim();
  }

  function sizeKeysMatch(a, b) {
    if (normalize(a) === normalize(b)) return true;
    return formatSleeveSize(a) === formatSleeveSize(b) && formatSleeveSize(a) !== '';
  }

  function variantHasPrint(variant, printName) {
    var wanted = normalize(printName);
    if (!wanted || !variant) return false;
    var parts = [variant.color, variant.size, variant.option1, variant.option2, variant.option3].concat(
      variant.options || []
    );
    return parts.some(function (part) {
      return normalize(part) === wanted;
    });
  }

  function choosableOptions(product) {
    if (!product || !product.options) return [];
    return product.options.filter(function (option) {
      if (isPrintOption(option) || isFabricOption(option)) return false;
      if (normalize(option.name) === 'title') return false;
      var values = uniqueValues(option.values);
      if (!values.length) return false;
      if (values.every(isOneSize)) return false;
      if (isSleeveProduct(product) && isSizeOption(option)) return true;
      return values.length > 1;
    });
  }

  function requiredOptions(product) {
    return choosableOptions(product);
  }

  function optionValueFor(variant, option, product) {
    if (!variant || !option) return '';
    var position = Number(option.position || 0);
    if (variant.options && variant.options.length && position > 0) {
      return variant.options[position - 1] || '';
    }
    if (position === 1) return variant.option1 || '';
    if (position === 2) return variant.option2 || '';
    if (position === 3) return variant.option3 || '';
    var name = normalize(option.name);
    if (name === 'size') return variant.size || '';
    if (name === 'color' || name === 'colour' || name === 'print' || name === 'fabric') return variant.color || '';
    return '';
  }

  function pickVariant(product, optionValues) {
    if (!product || !product.variants || !product.variants.length) return null;
    var needed = requiredOptions(product);
    var pool = product.variants.slice();
    needed.forEach(function (option) {
      var wanted = optionValues[option.name];
      if (!wanted) return;
      var matched = pool.filter(function (variant) {
        var actual = optionValueFor(variant, option, product);
        if (isSleeveProduct(product) && isSizeOption(option)) {
          return sizeKeysMatch(actual, wanted);
        }
        return normalize(actual) === normalize(wanted);
      });
      if (matched.length) pool = matched;
    });
    var printMatched = pool.filter(function (variant) {
      return variantHasPrint(variant, state.printName);
    });
    if (printMatched.length) pool = printMatched;
    var available = pool.filter(function (variant) {
      return variant.available;
    });
    return available[0] || pool[0] || product.variants[0];
  }

  function setImage(img, wrap, src, alt) {
    if (!img) return;
    if (src) {
      img.src = src;
      img.alt = alt || '';
      if (wrap) wrap.classList.remove('is-empty');
    } else {
      img.removeAttribute('src');
      img.alt = '';
      if (wrap) wrap.classList.add('is-empty');
    }
  }

  function queryPrint() {
    try {
      return new URL(window.location.href).searchParams.get('print') || '';
    } catch (error) {
      return '';
    }
  }

  function setPrintQuery(handle, push) {
    try {
      var url = new URL(window.location.href);
      if (handle) url.searchParams.set('print', handle);
      else url.searchParams.delete('print');
      if (push) history.pushState({ lcPrint: handle || '' }, '', url);
      else history.replaceState({ lcPrint: handle || '' }, '', url);
    } catch (error) {
      /* ignore */
    }
  }

  function showError(message) {
    if (!errorBox) return;
    if (message) {
      errorBox.hidden = false;
      errorBox.textContent = message;
    } else {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }
  }

  function embroideryText() {
    return textInput ? textInput.value.trim() : '';
  }

  function currentVariant() {
    if (!state.product) return null;
    return pickVariant(state.product, state.optionValues);
  }

  function productNodeList() {
    return panel.querySelectorAll('[data-lc-item]');
  }

  function itemRow(node) {
    return node && node.closest ? node.closest('.lc-customise__item') : null;
  }

  function parseProduct(node) {
    var row = itemRow(node) || node;
    var jsonNode = row ? row.querySelector('[data-lc-item-json]') : null;
    if (!jsonNode) return null;
    try {
      return JSON.parse(jsonNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function catsFor(node) {
    var row = itemRow(node);
    return row ? String(row.getAttribute('data-lc-cats') || '') : '';
  }

  function isCustomisableItem(node) {
    var item = node && node.getAttribute ? node : null;
    var handle = item ? String(item.getAttribute('data-product-handle') || '').toLowerCase() : '';
    if (handle === 'liberty-pjs' || handle === 'embroidery' || handle === 'embroidery-personalisation') return false;
    var cats = ' ' + catsFor(node) + ' ';
    if (cats.indexOf(' sleepwear ') !== -1) return false;
    return cats.indexOf(' bags ') !== -1;
  }

  function itemInCategory(node) {
    return isCustomisableItem(node);
  }

  function hideRetiredCategories() {
    panel.querySelectorAll('[data-lc-cat]').forEach(function (el) {
      el.hidden = true;
    });
    var tabs = panel.querySelector('[data-lc-cat-tabs]');
    if (tabs) tabs.hidden = true;
    if (!categorySelect) return;
    Array.prototype.slice.call(categorySelect.options).forEach(function (option) {
      if (option.value !== 'bags') option.remove();
    });
  }

  function syncCategoryUi() {
    state.category = 'bags';
    if (categorySelect && categorySelect.querySelector('option[value="bags"]')) {
      categorySelect.value = 'bags';
    }
  }

  function moneyLabel(cents) {
    var n = Math.round(Number(cents) / 100);
    if (!isFinite(n)) return '—';
    return 'AED ' + n;
  }

  function embroideryComplete() {
    return !!(embroideryText() && state.colour);
  }

  function sleeveSizeChosen() {
    if (!state.product || !isSleeveProduct(state.product)) return true;
    var sizeOpt = choosableOptions(state.product).find(isSizeOption);
    if (!sizeOpt) return true;
    return !!state.optionValues[sizeOpt.name];
  }

  function showPersonaliseStep() {
    return !!(state.product && sleeveSizeChosen());
  }

  function resetColour() {
    state.colour = '';
    panel.querySelectorAll('[data-lc-colour]').forEach(function (node) {
      node.setAttribute('aria-pressed', 'false');
    });
  }

  function loadEmbroideryVariant(done) {
    if (embroideryVariantId) {
      if (typeof done === 'function') done(embroideryVariantId);
      return;
    }
    var handles = ['lc-embroidery-personalisation', 'embroidery', 'embroidery-personalisation', 'personalisation'];
    function next(index) {
      if (index >= handles.length) {
        if (typeof done === 'function') done(0);
        return;
      }
      fetch('/products/' + handles[index] + '.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (product) {
          var variant = product && product.variants && product.variants[0];
          if (variant && variant.id) {
            embroideryVariantId = Number(variant.id) || 0;
            if (variant.price != null && Number(variant.price) > 0) {
              embroideryFeeCents = Number(variant.price);
            }
            if (typeof done === 'function') done(embroideryVariantId);
            return;
          }
          next(index + 1);
        })
        .catch(function () {
          next(index + 1);
        });
    }
    next(0);
  }

  function fillPieceSelect() {
    if (!pieceSelect) return;
    var currentHandle = state.product && state.product.handle ? state.product.handle : '';
    var html = '<option value="">Choose a bag or accessory</option>';
    var visible = 0;
    productNodeList().forEach(function (node) {
      var row = itemRow(node);
      if (!row || row.hidden) return;
      var product = parseProduct(node);
      if (!product) return;
      visible += 1;
      var selected = product.handle === currentHandle ? ' selected' : '';
      html +=
        '<option value="' +
        String(product.handle).replace(/"/g, '&quot;') +
        '"' +
        selected +
        '>' +
        String(product.title).replace(/</g, '&lt;') +
        '</option>';
    });
    pieceSelect.innerHTML = html;
    if (currentHandle) pieceSelect.value = currentHandle;
    if (catEmpty) catEmpty.hidden = visible > 0;
  }

  function filterItems() {
    var shown = 0;
    panel.querySelectorAll('.lc-customise__item').forEach(function (row) {
      var node = row.querySelector('[data-lc-item]');
      var match = itemInCategory(node);
      row.hidden = !match;
      if (match) shown += 1;
    });
    if (catEmpty) catEmpty.hidden = shown > 0;
    syncCategoryUi();
    fillPieceSelect();
  }

  function setCategory(category) {
    state.category = 'bags';
    filterItems();
    if (state.product) {
      var selected = panel.querySelector('[data-lc-item][aria-pressed="true"]');
      if (selected && !itemInCategory(selected)) {
        state.product = null;
        state.optionValues = {};
        state.changingPiece = false;
        panel.querySelectorAll('[data-lc-item]').forEach(function (node) {
          node.setAttribute('aria-pressed', 'false');
        });
        renderOptions();
        fillPieceSelect();
        syncSummary();
      }
    }
  }

  function revealTotals() {
    if (!totalsBox) return;
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) return;
    try {
      totalsBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    } catch (error) {
      totalsBox.scrollIntoView(true);
    }
  }

  function syncFlow() {
    var hasPiece = !!state.product;
    var personaliseReady = showPersonaliseStep();
    var showGrid = !hasPiece || state.changingPiece;
    panel.classList.toggle('is-piece-chosen', hasPiece && !state.changingPiece);
    if (itemStep) itemStep.hidden = !showGrid;
    if (chosenWrap) chosenWrap.hidden = !hasPiece || state.changingPiece;
    if (chosenLabel) chosenLabel.textContent = hasPiece ? state.product.title : '';
    if (pieceOptions) pieceOptions.hidden = !hasPiece;
    if (personalise) personalise.hidden = !personaliseReady;
    if (summaryTitle) summaryTitle.textContent = 'Your order';
  }

  function renderSummaryOptions() {
    if (!summaryOptions) return;
    summaryOptions.innerHTML = '';
    var options = state.product ? requiredOptions(state.product) : [];
    options.forEach(function (option) {
      var row = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = option.name;
      dd.textContent = optionLabel(state.product, option, state.optionValues[option.name]) || '—';
      row.appendChild(dt);
      row.appendChild(dd);
      summaryOptions.appendChild(row);
    });
    summaryOptions.hidden = !options.length;
  }

  function syncSummary() {
    var variant = currentVariant();
    var name = embroideryText();
    if (summaryPrint) summaryPrint.textContent = state.printName || '—';
    if (summaryItem) summaryItem.textContent = state.product ? state.product.title : '—';
    if (summaryName) summaryName.textContent = name || '—';
    if (summaryColour) summaryColour.textContent = state.colour || '—';
    renderSummaryOptions();
    var itemCents = 0;
    if (variant && variant.price != null) itemCents = Number(variant.price) || 0;
    else if (state.product && state.product.price != null) itemCents = Number(state.product.price) || 0;
    var feeCents = embroideryComplete() ? embroideryFeeCents : 0;
    if (summaryPrice) summaryPrice.textContent = itemCents ? moneyLabel(itemCents) : '—';
    if (summaryEmbroideryRow) summaryEmbroideryRow.hidden = !feeCents;
    if (summaryEmbroideryFee && feeCents) summaryEmbroideryFee.textContent = moneyLabel(feeCents);
    if (summaryTotal) {
      if (itemCents || feeCents) summaryTotal.textContent = moneyLabel(itemCents + feeCents);
      else summaryTotal.textContent = '—';
    }
    if (honestyNote) {
      honestyNote.textContent = feeCents
        ? 'Embroidery is AED 30 and is included in this total.'
        : 'Embroidery is AED 30. It is added to this total when you choose a name and colour.';
    }
    if (variantInput) variantInput.value = variant ? variant.id : '';
    if (propFabric) propFabric.value = state.printName || '';
    if (propName) propName.value = name;
    if (propColour) propColour.value = state.colour || '';
    if (propEmbroidery) propEmbroidery.value = feeCents ? moneyLabel(feeCents) : 'AED 30';

    var needed = state.product ? requiredOptions(state.product) : [];
    var optionsOk = needed.every(function (option) {
      return !!state.optionValues[option.name];
    });
    var ready = !!(state.product && variant && optionsOk && name && state.colour);
    if (submit) submit.disabled = !ready;
    if (ready) showError('');
    syncFlow();
    if (ready && !orderWasReady) revealTotals();
    orderWasReady = ready;
  }

  function renderOptions() {
    if (!optionsWrap) return;
    optionsWrap.innerHTML = '';
    var options = state.product ? choosableOptions(state.product) : [];
    if (fabricNote) {
      fabricNote.hidden = !state.product;
    }
    if (sleeveNote) {
      sleeveNote.hidden = !isSleeveProduct(state.product);
    }
    if (!options.length) {
      optionsWrap.hidden = true;
      return;
    }
    optionsWrap.hidden = false;
    options.forEach(function (option) {
      var values = uniqueValues(option.values);
      var field = document.createElement('div');
      field.className = 'lc-customise__option';
      var label = document.createElement('p');
      label.className = 'lc-customise__field-label';
      label.textContent = isSleeveProduct(state.product) && isSizeOption(option) ? 'Size' : option.name;
      field.appendChild(label);
      var list = document.createElement('div');
      list.className = 'lc-customise__size-list';
      list.setAttribute('role', 'group');
      list.setAttribute('aria-label', option.name);
      var autoPick = values[0] && !(isSleeveProduct(state.product) && isSizeOption(option));
      if (!state.optionValues[option.name] && autoPick) {
        state.optionValues[option.name] = values[0];
      }
      values.forEach(function (value) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'lc-customise__size';
        button.textContent = optionLabel(state.product, option, value);
        button.setAttribute('data-lc-option-name', option.name);
        button.setAttribute('data-lc-option-value', value);
        var on = state.optionValues[option.name] === value;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) button.classList.add('is-active');
        list.appendChild(button);
      });
      field.appendChild(list);
      optionsWrap.appendChild(field);
    });
  }

  function setTextMode(mode) {
    state.mode = mode === 'initials' ? 'initials' : 'name';
    panel.querySelectorAll('[data-lc-text-mode]').forEach(function (button) {
      var on = button.getAttribute('data-lc-text-mode') === state.mode;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var max = state.mode === 'initials' ? 4 : 24;
    if (textInput) {
      textInput.maxLength = max;
      textInput.placeholder = state.mode === 'initials' ? 'Initials to embroider' : 'Name to embroider';
      if (textInput.value.length > max) textInput.value = textInput.value.slice(0, max);
    }
    if (textLabel) textLabel.textContent = state.mode === 'initials' ? 'Initials' : 'Name';
    if (textMax) textMax.textContent = String(max);
    if (textCount) textCount.textContent = String(embroideryText().length);
  }

  function selectItem(button) {
    var item = button && button.closest('[data-lc-item]') ? button.closest('[data-lc-item]') : button;
    if (!item) return;
    var product = parseProduct(item);
    if (!product) return;
    state.product = product;
    state.optionValues = {};
    state.changingPiece = false;
    resetColour();
    panel.querySelectorAll('[data-lc-item]').forEach(function (node) {
      node.setAttribute('aria-pressed', node === item ? 'true' : 'false');
    });
    renderOptions();
    fillPieceSelect();
    syncSummary();
    var target = showPersonaliseStep() ? personalise : pieceOptions;
    if (target) {
      try {
        target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } catch (error) {
        target.scrollIntoView(true);
      }
    }
  }

  function selectItemByHandle(handle) {
    if (!handle) {
      state.product = null;
      state.optionValues = {};
      state.changingPiece = false;
      resetColour();
      panel.querySelectorAll('[data-lc-item]').forEach(function (node) {
        node.setAttribute('aria-pressed', 'false');
      });
      renderOptions();
      syncSummary();
      return;
    }
    var match = panel.querySelector('[data-lc-item][data-product-handle="' + handle.replace(/"/g, '') + '"]');
    if (match) selectItem(match);
  }

  function openFlow(print, push) {
    state.printHandle = print.handle || '';
    state.printName = print.name || '';
    state.printImage = print.image || '';
    if (printTitle) printTitle.textContent = state.printName;
    if (printCaption) printCaption.textContent = state.printName;
    setImage(printPhoto, printMedia, state.printImage, state.printName);
    if (summaryPrint) summaryPrint.textContent = state.printName || '—';
    if (propFabric) propFabric.value = state.printName;
    root.classList.add('lc-liberty-library--customise');
    panel.hidden = false;
    if (browse) browse.hidden = true;
    setPrintQuery(state.printHandle, push);
    filterItems();
    syncSummary();
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      window.scrollTo(0, 0);
    }
    if (printTitle && typeof printTitle.focus === 'function') printTitle.focus();
  }

  function closeFlow(push) {
    root.classList.remove('lc-liberty-library--customise');
    panel.hidden = true;
    if (browse) browse.hidden = false;
    state.product = null;
    state.optionValues = {};
    state.category = 'bags';
    state.changingPiece = false;
    orderWasReady = false;
    if (textInput) textInput.value = '';
    panel.querySelectorAll('[data-lc-item]').forEach(function (node) {
      node.setAttribute('aria-pressed', 'false');
    });
    resetColour();
    renderOptions();
    filterItems();
    setTextMode('name');
    showError('');
    syncSummary();
    setPrintQuery('', push);
  }

  function printFromCard(card) {
    return {
      handle: card.getAttribute('data-print-handle') || '',
      name: card.getAttribute('data-print-name') || '',
      image: card.getAttribute('data-print-image') || '',
    };
  }

  function cardForHandle(handle) {
    if (!handle) return null;
    var match = root.querySelector('[data-lc-liberty-card][data-print-handle="' + handle.replace(/"/g, '') + '"]');
    if (match) return match;
    var cards = root.querySelectorAll('[data-lc-liberty-card]');
    for (var i = 0; i < cards.length; i += 1) {
      if (normalize(cards[i].getAttribute('data-print-handle')) === normalize(handle)) return cards[i];
      if (normalize(cards[i].getAttribute('data-print-name')) === normalize(handle)) return cards[i];
    }
    return null;
  }

  root.addEventListener('click', function (event) {
    var card = event.target.closest('[data-lc-liberty-card]');
    if (card && root.contains(card)) {
      event.preventDefault();
      openFlow(printFromCard(card), true);
      return;
    }
    var back = event.target.closest('[data-lc-customise-back]');
    if (back) {
      event.preventDefault();
      closeFlow(true);
      return;
    }
    var catBtn = event.target.closest('[data-lc-cat]');
    if (catBtn) {
      setCategory('bags');
      return;
    }
    var changePiece = event.target.closest('[data-lc-change-piece]');
    if (changePiece) {
      event.preventDefault();
      state.changingPiece = true;
      syncFlow();
      if (itemStep) {
        try {
          itemStep.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } catch (error) {
          itemStep.scrollIntoView(true);
        }
      }
      return;
    }
    var itemBtn = event.target.closest('[data-lc-item]');
    if (itemBtn) {
      selectItem(itemBtn);
      return;
    }
    var optionBtn = event.target.closest('[data-lc-option-value]');
    if (optionBtn && optionsWrap && optionsWrap.contains(optionBtn)) {
      var optionName = optionBtn.getAttribute('data-lc-option-name') || '';
      var optionValue = optionBtn.getAttribute('data-lc-option-value') || optionBtn.textContent.trim();
      if (optionName) state.optionValues[optionName] = optionValue;
      optionsWrap.querySelectorAll('[data-lc-option-name="' + optionName.replace(/"/g, '') + '"]').forEach(function (node) {
        var on = node === optionBtn;
        node.setAttribute('aria-pressed', on ? 'true' : 'false');
        node.classList.toggle('is-active', on);
      });
      var personaliseWasHidden = !!(personalise && personalise.hidden);
      syncSummary();
      if (personaliseWasHidden && personalise && !personalise.hidden) {
        try {
          personalise.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } catch (error) {
          personalise.scrollIntoView(true);
        }
      }
      return;
    }
    var modeBtn = event.target.closest('[data-lc-text-mode]');
    if (modeBtn) {
      setTextMode(modeBtn.getAttribute('data-lc-text-mode'));
      syncSummary();
      return;
    }
    var colourBtn = event.target.closest('[data-lc-colour]');
    if (colourBtn) {
      state.colour = colourBtn.getAttribute('data-colour-name') || '';
      panel.querySelectorAll('[data-lc-colour]').forEach(function (node) {
        node.setAttribute('aria-pressed', node === colourBtn ? 'true' : 'false');
      });
      syncSummary();
    }
  });

  if (categorySelect) {
    categorySelect.addEventListener('change', function () {
      setCategory('bags');
    });
  }

  if (pieceSelect) {
    pieceSelect.addEventListener('change', function () {
      selectItemByHandle(pieceSelect.value);
    });
  }

  if (textInput) {
    textInput.addEventListener('input', function () {
      if (textCount) textCount.textContent = String(textInput.value.length);
      syncSummary();
    });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var variant = currentVariant();
      var name = embroideryText();
      var needed = state.product ? requiredOptions(state.product) : [];
      if (!state.product || !variant) {
        showError('Please choose a piece.');
        return;
      }
      var missing = needed.find(function (option) {
        return !state.optionValues[option.name];
      });
      if (missing) {
        showError('Please choose a ' + missing.name.toLowerCase() + '.');
        return;
      }
      if (!name) {
        showError(state.mode === 'initials' ? 'Please add initials to embroider.' : 'Please add a name to embroider.');
        return;
      }
      if (!state.colour) {
        showError('Please choose an embroidery colour.');
        return;
      }

      showError('');
      submit.disabled = true;
      submit.classList.add('loading');
      var spinner = submit.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var bagProperties = {
        'Custom fabric': state.printName,
        Name: name,
        'Embroidery colour': state.colour,
        Embroidery: moneyLabel(embroideryFeeCents),
      };
      needed.forEach(function (option) {
        var value = state.optionValues[option.name];
        if (value) bagProperties[option.name] = value;
      });

      function extraSections() {
        var extra = {};
        if (cart && typeof cart.getSectionsToRender === 'function') {
          extra.sections = cart.getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
            .join(',');
          extra.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        return extra;
      }

      function handleCartResponse(response) {
        if (!response || response.status) {
          showError('This piece could not be added just now. Please try again.');
          return false;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return true;
        }
        if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'lc-liberty-customise',
            productVariantId: String(variant.id),
            cartData: response,
          });
        }
        if (response.sections && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else if (typeof cart.open === 'function') {
          cart.open(submit);
        }
        return true;
      }

      loadEmbroideryVariant(function () {
        if (!embroideryVariantId) {
          showError('Embroidery could not be added just now. Please try again.');
          submit.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          syncSummary();
          return;
        }
        var api = window.LCEmbroidery;
        var extra = extraSections();
        var addPromise;
        if (api && typeof api.addPersonalisedPair === 'function') {
          addPromise = api.addPersonalisedPair(
            { id: Number(variant.id), quantity: 1, properties: bagProperties },
            {
              id: embroideryVariantId,
              quantity: 1,
              properties: {
                _lc_embroidery_addon: '1',
                For: state.product.title,
                Print: state.printName,
                Name: name,
                'Embroidery colour': state.colour,
              },
            },
            extra
          );
        } else {
          var pair = 'lc' + Date.now().toString(36);
          bagProperties._lc_pair = pair;
          addPromise = fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: [
                { id: Number(variant.id), quantity: 1, properties: bagProperties },
                {
                  id: embroideryVariantId,
                  quantity: 1,
                  properties: {
                    _lc_embroidery_addon: '1',
                    _lc_pair: pair,
                    For: state.product.title,
                    Print: state.printName,
                    Name: name,
                    'Embroidery colour': state.colour,
                  },
                },
              ],
              sections: extra.sections,
              sections_url: extra.sections_url,
            }),
          }).then(function (response) {
            return response.json();
          });
        }
        addPromise
          .then(function (response) {
            return handleCartResponse(response);
          })
          .catch(function () {
            showError('This piece could not be added just now. Please try again.');
          })
          .finally(function () {
            submit.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            syncSummary();
          });
      });
    });
  }

  window.addEventListener('popstate', function () {
    var handle = queryPrint();
    if (!handle) {
      if (!panel.hidden) closeFlow(false);
      return;
    }
    var card = cardForHandle(handle);
    if (card) openFlow(printFromCard(card), false);
  });

  hideRetiredCategories();
  setTextMode('name');
  filterItems();
  loadEmbroideryVariant();
  var startHandle = queryPrint();
  if (startHandle) {
    var startCard = cardForHandle(startHandle);
    if (startCard) openFlow(printFromCard(startCard), false);
  }
})();
